<template>
  <v-dialog v-model="dialog" persistent max-width="1000" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="info" rounded block max-height="35" v-on="on" v-bind="attrs" v-if="podeAlterarIncluir"
        ><v-icon class="mr-2">mdi-plus</v-icon>Adicionar dependente</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold primary--text"
        >Adicionar dependente</v-card-title
      >
      <v-card-subtitle class="green lighten-4">Plano de saúde</v-card-subtitle>
      <v-card-text class="pt-4">
        <v-card flat class="grey lighten-4">
          <v-card-title class="font-weight-bold subtitle-2 pb-2"
            >Dependentes disponíveis</v-card-title
          >
          <v-card-text>
            <v-data-table
              :items="getDependentesDisponiveis()"
              :headers="headers"
              hide-default-footer
              no-data-text="Nenhum dependente disponível"
              disable-sort
              :hide-default-header="isMobile()"
            >
              <template v-slot:[`item.selecionado`]="{ item }">
                <v-switch inset dense v-model="item.selecionado"></v-switch>
              </template>
              <template v-slot:[`item.vlrplano`]="{ item }">
                {{ formatarMoeda(item.vlrplano) }}
              </template>
              <template v-slot:[`item.vlrpagocoasul`]="{ item }">
                <span class="blue--text font-weight-bold">{{
                  formatarMoeda(item.vlrpagocoasul)
                }}</span>
              </template>
              <template v-slot:[`item.vlrpagofunc`]="{ item }">
                <span class="green--text font-weight-bold">{{
                  formatarMoeda(item.vlrpagofunc)
                }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-card
          flat
          class="grey lighten-4 rounded-lg mt-2"
          v-if="getDependentesDisponiveis().length > 0"
        >
          <v-card-title class="font-weight-bold subtitle-2 pb-2"
            >Valores simulados</v-card-title
          >
          <v-card-text>
            <v-list dense class="grey lighten-4 pt-0 pb-0">
              <v-row dense>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Valor total do plano</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-bold subtitle-1">{{
                        valoresCalculados().vlrCalcPlano
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >A Coasul pagará</v-list-item-subtitle
                      >
                      <v-list-item-title
                        class="font-weight-bold subtitle-1 blue--text"
                        >{{
                          valoresCalculados().vlrCalcCoasul
                        }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-list-item>
                    <v-list-item-content class="justify-end">
                      <v-list-item-subtitle
                        >O colaborador pagará</v-list-item-subtitle
                      >
                      <v-list-item-title
                        class="font-weight-bold subtitle-1 green--text"
                        >{{
                          valoresCalculados().vlrCalcFunc
                        }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialogAddDepend" max-width="850" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              rounded
              color="info"
              min-width="120"
              :disabled="dependentesAnexar().length == 0"
              >Confirmar</v-btn
            >
          </template>
          <anexar-docs-plano-saude
            :codConfig="17"
            :dependentes="dependentesAnexar()"
          >
            <v-spacer></v-spacer>
            <v-dialog v-model="dialogActTermos" max-width="650" scrollable>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="info"
                  rounded
                  min-width="210"
                  >Confirmar documentos</v-btn
                >
              </template>
              <texto-aceitar-termos>
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  color="info"
                  :disabled="!aceitouTermos"
                  min-width="190"
                  @click="solicitarAdicaoDependentes()"
                  :loading="adicionando"
                  >Finalizar solicitação</v-btn
                >
                <v-btn text rounded @click="dialogActTermos = false"
                  >Fechar</v-btn
                >
              </texto-aceitar-termos>
            </v-dialog>
            <v-btn @click="dialogAddDepend = false" text rounded>Fechar</v-btn>
          </anexar-docs-plano-saude>
        </v-dialog>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatMoeda } from "@/global";
import { mapActions, mapMutations, mapState } from "vuex";
import AnexarDocsPlanoSaude from "../components/AnexarDocsPlanoSaude.vue";
import TextoAceitarTermos from "../components/TextoAceitarTermos.vue";
import axios from "axios";

export default {
  components: {
    AnexarDocsPlanoSaude,
    TextoAceitarTermos,
  },
  watch: {
    dialogAddDepend: async function (open) {
      if (open) {
        await this.getConfigDocs();
      }
    },
    dialogActTermos: async function (open) {
      if (open) {
        this.setAceitouTermos(false);
        await this.getTextoAceitarTermos();
      }
    },
  },
  computed: mapState("planoSaude", [
    "meuPlano",
    "aceitouTermos",
    "docsAnexados",
    "podeAlterarIncluir"
  ]),
  data: () => ({
    dialogActTermos: false,
    dialogAddDepend: false,
    dialog: false,
    adicionando: false,
    headers: [
      { text: "Selecionar", value: "selecionado" },
      { text: "Cód", value: "codigo" },
      { text: "Nome", value: "nome" },
      { text: "Parentesco", value: "parentesco" },
      { text: "Valor plano", value: "vlrplano" },
      { text: "Coasul paga", value: "vlrpagocoasul" },
      { text: "Colaborador paga", value: "vlrpagofunc" },
    ],
  }),
  methods: {
    ...mapMutations("planoSaude", ["setAceitouTermos"]),
    ...mapActions("planoSaude", ["getConfigDocs", "getTextoAceitarTermos"]),
    getDependentesDisponiveis() {
      return this.meuPlano.dependentes.filter(
        (d) => !d.possuiplano && d.podeutilizar && !d.solicitouadicao
      );
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    valoresCalculados() {
      var vlrTotalPlano = 0;
      var vlrTotalPgCoasul = 0;
      var vlrTotalPgFunc = 0;

      this.meuPlano.dependentes
        .filter((dep) => dep.selecionado || dep.possuiplano)
        .forEach((d) => {
          vlrTotalPlano += d.vlrplano;
          vlrTotalPgCoasul += d.vlrpagocoasul;
          vlrTotalPgFunc += d.vlrpagofunc;
        });

      return {
        vlrCalcPlano: this.formatarMoeda(vlrTotalPlano),
        vlrCalcCoasul: this.formatarMoeda(vlrTotalPgCoasul),
        vlrCalcFunc: this.formatarMoeda(vlrTotalPgFunc),
      };
    },
    isMobile() {
      return this.$mq == "sm";
    },
    dependentesAnexar() {
      return this.getDependentesDisponiveis().filter((dep) => dep.selecionado);
    },
    async solicitarAdicaoDependentes() {
      this.adicionando = true;
      await axios
        .post(
          "/colaborador/plano-saude/adicionar-dependente",
          JSON.stringify({
            dependentes: this.dependentesAnexar(),
            documentos: this.docsAnexados,
          })
        )
        .then((res) => {
          if (res.data.success) {
            this.$router.go();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.adicionando = false;
    },
  },
};
</script>

<style>
</style>